import { Component, OnInit, ViewChild, ChangeDetectorRef } from "@angular/core";
import { MatSort } from "@angular/material/sort";
import { ActivatedRoute, Router } from "@angular/router";
import { FiltersService } from "src/app/core/services/filters.service";
import { ContractModel } from "src/app/global/contract-filter-model";
import { TVDService } from "../../services/tvd.service";
import { TVDDetailsConfigService } from "../../services/tvd-details-config.service";
import { Subscription, combineLatest, skip } from "rxjs";
import {
  TVDLocationDetails,
  TVDLocationDetailsRowData,
  TVDProductDetails,
  TVDProductDetailsRow,
  TVDTableHeader,
  ModifiedFormData,
  TvdLocationServicesDetails,
  TVDLocationServicesDetailsRowData,
  eroiIds,
  componentConfigAndMetricsIdsMap,
  TVDRateDetailsResponse,
  PestTileMap,
  availableBrandGroups,
  TvdAdvancedFilterOption,
  TvdLocationAdvancedFilter,
  TvdProductAdvancedFilter,
  TvdDrillDownGrouping,
  SelectedTvdAdvancedFilters,
  TvdDrillInMetricTiles} from "../../types/tvd-types";
import {
  MatPaginator,
  MatPaginatorIntl,
  PageEvent,
} from "@angular/material/paginator";
import { MixpanelService } from "src/app/core/services/mixpanel.service";
import { CustomPaginator } from "./CustomPaginatorConfigurationProduct";
import { orderBy } from 'lodash';
import * as XLSX from 'xlsx';
import { CurrencyUomService } from 'src/app/core/services/currency-uom.service';
import { TvdCostAssumptionsService } from "../../services/tvd-cost-assumptions.service";
import { ParseNumberPipe } from "src/app/core/pipes/parse-number.pipe";
import { FlatMetricCostAssumptions, MetricCostAssumptions } from "src/app/core/services/ebr-api-client/ebr-api-client.g";
import { eroiService } from "../../services/eroi-metric.service";
import { CurrencySymbolPipe } from "src/app/core/pipes/currency-symbol.pipe";
import { KpiCardLayout, TvdKpiCardBuilder } from "../../builders/tvd-kpi-card-builder";
import { TvdMetricDisplayDataBuilder } from "../../builders/tvd-metric-display-data.builder";
import { TvdMetricResolver } from "../../resolvers/tvd-metric.resolver";
import { CostAssumptionsEligibilityResolver } from "../../resolvers/cost-assumptions-eligibility.resolver";
import { MetricCostAssumptionsPayloadBuilder } from "../../builders/metric-cost-assumptions-payload.builder";
import { CostAssumptionsLayoutResolver } from "../../resolvers/cost-assumptions-layout.resolver";

@Component({
    selector: "tvd-details",
    templateUrl: "./tvd-details-page.component.html",
    styleUrls: ["./tvd-details-page.component.scss"],
    providers: [
        { provide: MatPaginatorIntl, useValue: CustomPaginator() },
        ParseNumberPipe
    ],
    standalone: false
})
export class TvdDetailsPageComponent implements OnInit {
  @ViewChild(MatSort) sort!: MatSort;
  @ViewChild(MatPaginator) paginator!: MatPaginator;

  filters: ContractModel | undefined;
  filtersSubscription: Subscription | undefined;
  tvdLocationsDetailsSubscription: Subscription | undefined;
  tvdProductDetailsSubscription: Subscription | undefined;
  modifiedTVDDollarsSubscription: Subscription | undefined;
  loadingOverlaySubscription: Subscription | undefined;
  showLoadingOverlay: boolean = false;

  tvdPestLocationsDetailsSubscription: Subscription | undefined;
  currencySubscription: Subscription | undefined;

  showInEnterpriseTermsSubscription: Subscription | undefined;

  //left block variables
  metricUnits: string = "";
  tvdDollars: number = 0;
  tvdMetricQuantity: number = 0;
  modifiedTvdMetricQuantity: number = 0;

  //tabName and metricName variables
  tabSelected: string = "product";
  groupId: string = "";
  metricId: string = "";
  groupBy: string = "product";
  metricName: string = "";
  metricDisplayName: string = "";
  // TODO: The formattedMetricName is used in multiple places as a key for mapping to cost assumptions and rates. This is a bit brittle and can easily lead to bugs if we have metrics with similar names. We should consider having a clear mapping of metric display names to their corresponding cost assumption metric names to avoid this issue.
  // TODO: Rename formattedMetricName to eroid as it is actually an eroid and not a formatted metric name. This is confusing and can lead to bugs if we have metrics with similar names. We should have a clear mapping of metric display names to their corresponding eroids to avoid this issue.
  formattedMetricName: string = "";
  enterpriseTermDisplayName: string = "";

  navigationState: {
    brandGroup: availableBrandGroups;
    brands: string[];
  } = {
    brandGroup: availableBrandGroups.ALL,
    brands: [],
  }

  //Metric Product Details Variables
  tvdProductDetailsData: TVDProductDetails | undefined = undefined;
  tvdProductsRowData: TVDProductDetailsRow[] | undefined;
  tvdProductsRowDataPaginated: TVDProductDetailsRow[] | undefined;
  tableProductHeaderColumns: TVDTableHeader[] = [];
  productSortBy: string = "estimatedMetricDollars";

  // Location Details Variables
  tvdLocationDetailsData: TVDLocationDetails | undefined = undefined;
  tvdLocationRowData: TVDLocationDetailsRowData[] | undefined;
  tvdLocationRowDataPaginated: TVDLocationDetailsRowData[] | undefined;
  tableLocationHeaderColumns: TVDTableHeader[] = [];
  locationSortBy: string = "estimatedMetricDollars";

  // Pest Location Services Details Variables
  tvdLocationServicesDetailsData: TvdLocationServicesDetails | undefined = undefined;
  tvdLocationServicesRowData: TVDLocationServicesDetailsRowData[] | undefined;
  tvdLocationServicesRowDataPaginated: TVDLocationServicesDetailsRowData[] | undefined;
  tableLocationServicesHeaderColumns: TVDTableHeader[] = [];
  locationServicesSortBy: string = "estimatedMetricDollars";
  hasTwoMetrics : boolean = false;
  hasTwoMultipliers : boolean = false;
  avgMetricUnits: string = '';
  tvdRateDetailsResponse: TVDRateDetailsResponse | undefined;
  isScalingFactor = 'scaling factor';

  //right block variables
  totalLocations: string = "0";
  totalServices: string = "0";
  totalContributingProducts: string = "0";
  avgTVDMetricDollars: number = 0;
  avgTVDMetricQuantity: number = 0;
  secondaryMetricSum: number = 0;

  // Export
  isExportModalOpen: boolean = false;
  isExportDownloading: boolean = false;
  exportFileName: string = '';
  exportModalTitle: string = 'Export Locations Data';
  exportMixpanelEventName: string = 'TVD Location Details Exported';
  additionalExportProperties: any = {};

  // Selected program for Product and Location drillthrough
  selectedProgram: string = "";

  isDrawerOpen : boolean = false;
  costAssumptionsVisible = false;
  costAssumptionValue: number = 0;
  costAssumptionValue2: number = 0;

  modifiedTVDDollars: number = 0;
  modifiedAvgTVDMetricDollars: number = 0;
  secondMultiplier: number = 1;
  private rawApiTotalDollars: number = 0;

  showInEnterpriseTerms: boolean = true;

  displayLoader: boolean = false;

  // No dollar value metrics which should show N/A in drilldowns
  noDollarValueMetrics: string[] = ['Employee Safety', 'Greenhouse Gases', 'CO2e from Energy Use', 'CO2e from Transportation', 'CO2e from Packaging Manufacture'];

  ROOMS_NIGHTS_SAVED = PestTileMap[eroiIds.ROOMNIGHTSSAVED];
  SETUP_SERVICES = PestTileMap[eroiIds.SETUPSERVICES];
  NO_CHARGE_ADDITIONAL_SERVICES = PestTileMap[eroiIds.NOCHARGEADDITIONALSERVICES];

  toggleAdvancedFilterSelection: boolean = false;
  displayLoaderForFilterData: boolean = false;
  advancedFilterOptions: TvdAdvancedFilterOption[] | undefined;
  advancedFilterData: TvdAdvancedFilterOption[] = [];
  selectedLocationFilters: TvdLocationAdvancedFilter = {};
  selectedProductFilters: TvdProductAdvancedFilter = {};
  excludeKeys: string[]= [];
  currentSelectedFilters: SelectedTvdAdvancedFilters  = {
    "siteNumber": [],
    "siteName": [],
    "country": [],
    "state": [],
    "city": [],
    "zipCode": [],
    "productGroup": [],
    "productName": [],
    "productSku": []};

  private readonly ELIGIBLE_FILTER_DIVISIONS: readonly string[] = ['Institutional', 'QSR'];

  TvdDrillDownGrouping = TvdDrillDownGrouping;
  currencySymbol: string = '';
  currencyCode: string = '';
  // Backing field for KPI cards bound from the template
  tvdDrillInMetricTiles: TvdDrillInMetricTiles[] = [];
  // Whether KPI cards are ready to render
  kpiCardsLoaded: boolean = false;

  constructor(
    private _router: Router,
    private _route: ActivatedRoute,
    private _filterService: FiltersService,
    private _tvdService: TVDService,
    private _tvdDetailsConfigService: TVDDetailsConfigService,
    private _tvdCostAssumptionsService: TvdCostAssumptionsService,
    private _tvdKpiCardBuilder: TvdKpiCardBuilder,
    private _tvdMetricDisplayDataBuilder: TvdMetricDisplayDataBuilder,
    private _tvdMetricResolver: TvdMetricResolver,
    private _mixpanelService: MixpanelService,
    private _currencyUomService: CurrencyUomService,
    private _cdr: ChangeDetectorRef,
    private _parseNumberPipe: ParseNumberPipe,
    private _currencySymbolPipe: CurrencySymbolPipe,
    private _eroiService: eroiService,
    private _costAssumptionsEligibilityResolver: CostAssumptionsEligibilityResolver,
    private _metricCostAssumptionsPayloadBuilder: MetricCostAssumptionsPayloadBuilder,
    private _costAssumptionsLayoutResolver: CostAssumptionsLayoutResolver
  ) {
    const navigation = this._router.currentNavigation();
    const state = navigation?.extras.state as { brandGroup: availableBrandGroups, brands: string[] };
    if (state) {
      this.navigationState = state;
    }
  }


  async ngOnInit() {
    this._mixpanelService.initializeActiveDurationTracking(); // start active duration tracking
    this.filtersSubscription =
    this._filterService.selectedFiltersObservable.subscribe(
      (f) => (this.filters = f)
    );
    this.showInEnterpriseTermsSubscription = this._tvdService.showInEnterpriseTermsObservable.subscribe((f) => {
      this.showInEnterpriseTerms = f
    });
    this.loadingOverlaySubscription = this._tvdService.showLoadingOverlayObservable.subscribe(loading => this.showLoadingOverlay = loading);


    this.modifiedTVDDollarsSubscription = this._tvdService.modifiedMonetaryContributionObservable.subscribe(
      (modifiedMonetaryContribution) => {
        let metricName = this.getFormattedPestMetricName(this.metricName);
        const componentValue = modifiedMonetaryContribution.get(metricName);
        this.modifiedTVDDollars = this.getFormattedNumber(componentValue);
        if (!this.isPestView() && componentValue !== undefined) {
          this.setModifiedAverageTVDMetricDollars();
        } else if (componentValue && metricName == 'productivity') {
          this.modifiedAvgTVDMetricDollars = Math.round(
            this.modifiedTVDDollars / this.getFormattedNumber(this.totalLocations)
          );
        } else if (componentValue && this._tvdDetailsConfigService.isRetrievalRequiredFromAPI(this.metricName)) {
          this.modifiedAvgTVDMetricDollars = this.costAssumptionValue > 0 ? this.costAssumptionValue : this.modifiedAvgTVDMetricDollars;
        }
        
        this.buildKpiCards();
        this.kpiCardsLoaded = true;       // if you gate render on this flag
        this._cdr.detectChanges(); 
    });

    //Non-Pest Locations Data subscription
    this.tvdLocationsDetailsSubscription = this._tvdService.tvdLocationDetailsDataObservable.subscribe(
      (locationsData) => {
        this.tvdLocationDetailsData = locationsData;
        this.costAssumptionValue = this.getCostAssumptionValue();
        // Update dependent properties
        this.setTVDLocationDetails();
        if (this.paginator) {
          this.updatePageData(0, this.paginator.pageSize);
        }

        this.buildKpiCards();
      
        this.kpiCardsLoaded = true;       // if you gate render on this flag
        this._cdr.detectChanges(); 
      }
    );

    //Pest Locations Data subscription
    this.tvdPestLocationsDetailsSubscription = this._tvdService.tvdPestLocationDetailsDataObservable.subscribe(
      (locationsData) => {
        this.tvdLocationServicesDetailsData = locationsData;
        // Update dependent properties
        [this.costAssumptionValue, this.costAssumptionValue2] = this.getPestCostAssumptionValue();
        this.setTVDLocationServicesDetails();
        if (this.paginator) {
          this.updatePageData(0, this.paginator.pageSize);
        }
        // Update KPI cards when calculations change
        this.buildKpiCards();
        this.kpiCardsLoaded = true;       // if you gate render on this flag
        this._cdr.detectChanges();
      }
    );


    //Non-Pest Products Data subscription
    this.tvdProductDetailsSubscription = this._tvdService.tvdProductDetailsDataObservable.subscribe(
      (productData) => {
        this.tvdProductDetailsData = productData;
        this.costAssumptionValue = this.getCostAssumptionValue();
        // Update dependent properties
        this.setTVDProductDetails();
        if (this.paginator) {
          this.updatePageData(0, this.paginator.pageSize);
        }
        this.buildKpiCards();
        this.kpiCardsLoaded = true;       // if you gate render on this flag
        this._cdr.detectChanges();
      }
    );


    this._tvdService.currentProgramSelectedObservable.subscribe((program) => {
      this.selectedProgram = program || '';
    });

    // Re-fetch TVD details when currency changes
    this.currencySubscription = combineLatest([
      this._currencyUomService.selectedCurrency$,
      this._currencyUomService.selectedUom$,
    ]).pipe(skip(1)).subscribe(async () => {
      if(!this.hasEnteredCostAssumption()){
        await this.reFetchTVDDetails();
      }
    });

    // If cost assumptions has been entered, let the tvd-sidenavbar component update/convert the form values first.
    // Assumes that tvd-sidenavbar will then updated this observable and trigger this subscription to re-fecth details data.
    this._tvdCostAssumptionsService.costAssumptionsUpdatedFormValuesObservable.pipe(skip(1)).subscribe(async () => {
      if(this.hasEnteredCostAssumption()){
        await this.reFetchTVDDetails();
      }
    });
      

    var isCostAssumptionsVisible = this._costAssumptionsEligibilityResolver.resolveFromFilters(this.filters);
    
    // Fetch TVD rates details if division is not Distributor, as Distributor doesn't have rates details and it would save an unnecessary API call
    if(isCostAssumptionsVisible) {
      // TODO: Why are we triggering (or subscribing) the fetch of TVD rate details here? Consider whether this should be done conditionally or moved to a more appropriate lifecycle hook to avoid unnecessary API calls.
      await this.fetchTvdRateDetails();
    }

    await this.initializeComponent();
    if(this.formattedMetricName === eroiIds.FURNITUREPRESERVATIONASSETS){
      // Set the second multiplier for Furniture Preservation (Assets/Energy) metric
      this.secondMultiplier = this._tvdService.getDefaultRate("furniturepreservationassetsmultiplier", null) as number;
    }
    this.updateCostAssumptionsVisibility();
    this.getCurrencySymbol();
  }

  async initializeComponent() {
    if (this.filters) {
      this._route.queryParams.subscribe(async (params) => {
        this.groupBy = params["groupBy"];
        this.metricName = params["metricName"];
        this.metricId = params["metricId"];
        this.groupId = params["groupId"];

        this.metricDisplayName = this.metricName; // Used in UI
        
        if(this.metricName === "General Contractor (GC) Cost Avoidance") {
          this.metricName = "General Contractor Cost Avoidance"; //US-514484
        }
        //format metric name to be used in sidebar nav component
        // TODO: Create a function for constructing an eroid from the metricName to avoid the brittleness of relying on string manipulation in multiple places. This would also make it clearer that formattedMetricName is actually an eroid and not just a formatted metric name, which can be confusing and lead to bugs if we have metrics with similar names. We should have a clear mapping of metric display names to their corresponding eroids to avoid this issue.
        this.formattedMetricName =  this.metricName.replace(/[()\-]/g, '').split(" ").join("_").toLowerCase();
      // TODO: This is a code smell. The formattedMetricName is derived from metricName but is used as a key for getting the metric IDs for cost assumptions. This is a bit brittle and can easily break if we have metrics with similar names. We should consider having a mapping of metric display names to their corresponding cost assumption metric names to avoid this issue.
        this.enterpriseTermDisplayName = this._eroiService.mapIdToEnterpriseTermsTitle(this.metricId || this.formattedMetricName);
        
        //Story-559726: Map display name to enum ID for cost assumption lookup
        if(this.metricName === "Set-up Services") {
          // TODO: This is a code smell. Updating the formattedMetricName aftered it is referenced before this block to map to the correct cost assumption metric is brittle and can easily break if we have metrics with similar names. We should consider a more robust solution, such as having a mapping of metric display names to their corresponding cost assumption metric names. 
          this.formattedMetricName = "setup_services";
        }

        if(this.isPestView()) {
          [this.costAssumptionValue, this.costAssumptionValue2]= this.getPestCostAssumptionValue();
        } else {
          this.costAssumptionValue = this.getCostAssumptionValue();
        }
        await this.updateTVDDetails();
      });
    } else {
      // If filters are not applied, redirect to filter page
      alert("Please apply filters before navigating to TVD Details Page");
      this._router.navigate(["/filter"]);
    }
  }

  /**
   * Refreshes the TVD details and KPI cards by clearing cached data 
   * and re-fetching data from the API.
   */
  private async reFetchTVDDetails(): Promise<void> {
    this._currencyUomService.setCurrencyLoading(true);
    this._tvdService.setShowLoadingOverlay(true);
    // Clear cached data to force re-fetch
    this._tvdService.setTvdProductDetailsData(undefined);
    this._tvdService.setTvdLocationDetailsData(undefined);
    this._tvdService.setPestTvdLocationDetailsData(undefined);
    await this.updateTVDDetails();

    // Refresh summary dollar values from fresh API data
    this.buildKpiCards();
    this.kpiCardsLoaded = true; 
    this._tvdService.setShowLoadingOverlay(false);
    this._currencyUomService.setCurrencyLoading(false);
    this._cdr.detectChanges();
  }

  /* Method to calculate cost assumption value */
  private getCostAssumptionValue(): number {
    if (this.isCountryScopedCostAssumptions()) {
      return 0;
    }

    const savedFormData: ModifiedFormData = this._tvdService.getFormData();
    if (Object.keys(savedFormData).length) {
      let metricName = this.metricName?.toLowerCase();

      if (metricName !== 'productivity') {
        return Number(savedFormData[metricName]) || 0;
      } else {
        // For productivity, check if either foodservice or hospitality has a value
        const foodserviceValue = Number(savedFormData["foodservice"]) || 0;
        const hospitalityValue = Number(savedFormData["hospitality"]) || 0;
        //We use just productivity value alone for QSR and FRS (No cross into foodservice and hospitality)
        const productivityValue = Number(savedFormData["productivity"]) || 0;

        // Return the value if either foodservice or hospitality is greater than 0
        return foodserviceValue > 0 || hospitalityValue > 0 || productivityValue > 0
          ? Math.max(foodserviceValue, hospitalityValue, productivityValue) : 0;
      }
    }
    return 0;
  }

  /* Method to calculate cost assumption value */
  private getPestCostAssumptionValue(): [number, number] {
    const savedFormData: ModifiedFormData = this._tvdService.getFormData();
    if (Object.keys(savedFormData).length) {
      // TODO: This is a code smell. The formattedMetricName is derived from metricName but is used as a key for getting the metric IDs for cost assumptions. This is a bit brittle and can easily break if we have metrics with similar names. We should consider having a mapping of metric display names to their corresponding cost assumption metric names to avoid this issue.
      const metricsIds = componentConfigAndMetricsIdsMap.get(this.formattedMetricName);

      if (metricsIds && metricsIds.length) {
        if (metricsIds.length === 1) {
          this.costAssumptionValue = Number(savedFormData[metricsIds[0]]) || 0;
          return [this.costAssumptionValue, 0];
        } else {
          this.costAssumptionValue = Number(savedFormData[metricsIds[0]]) || 0;
          this.costAssumptionValue2 = Number(savedFormData[metricsIds[1]]) || 0;
          return [this.costAssumptionValue, this.costAssumptionValue2];
        }
      } else {
        return [0, 0];
      }
    }
    return [0, 0];
  }

  async onCostAssumptionsSaved() {
    // Country-scoped (multi-country) cost assumptions aren't recalculated client-side by
    // tvd-cost-assumptions.service (it only handles flat, single-region form data), so the
    // cached tables must be cleared to force a refetch that applies the per-country rates.
    if (this.isCountryScopedCostAssumptions()) {
      this._tvdService.setTvdProductDetailsData(undefined);
      this._tvdService.setTvdLocationDetailsData(undefined);
      this._tvdService.setPestTvdLocationDetailsData(undefined);
    }
    await this.updateTVDDetails();
  }

  async updateTVDDetails() {
    this.tabSelected = this.groupBy;

    // Reset KPI ready state while we fetch/update data
    this.kpiCardsLoaded = false;

    this.setTVDMetricValues();
    const normalizedMetricName = this.normalizeMetricName(this.metricName);

    this.displayLoader = true;
    // Handle pest view separately and exit early
    if (this.isPestView()) {
      await this.getTVDServicesDetailsDataAndUpdatePage(normalizedMetricName);
      this.buildKpiCards();
      this.kpiCardsLoaded = true;
      // Refresh KPI cards after data update
      this.displayLoader = false;
      return;
    }

    // Non-Pest view logic
    if (this.shouldShowAdvancedFilters()) {
      if (!this.advancedFilterOptions) {
        await this.loadAdvancedFilterOptions();
      } else {
        this.buildAdvancedFilterData();
      }
    }

    await this.getTVDDetailsDataAndUpdatePage(normalizedMetricName);
    // Refresh KPI cards after data update
    this.buildKpiCards();
    this.kpiCardsLoaded = true;
    this.displayLoader = false;
  }

  // Get TVD Details Data
  async getTVDDetailsDataAndUpdatePage(metricName: string) {
    // TODO: Encapsulate the logic for converting the metricName into an eroid instead of having the caller do it and passing the eroid to the request function. This will make it easier to maintain and less error prone as we won't have to worry about callers passing in metric names that don't match the expected format.
    // The commented out line below is an example of how this could be done, but it would require changes to the request function and potentially other parts of the codebase so it may not be worth doing at this time.
    // const normalizedMetricName = this.normalizeMetricName(this.metricName);
    const formData = this._tvdService.getFormData();
    const metricCostAssumptions = Object.keys(formData).length
      ? this._metricCostAssumptionsPayloadBuilder.build(
        formData,
        this._costAssumptionsLayoutResolver.resolveFromFilters(this.filters)
      )
      : undefined;

    const detailsDataNeeded = this.tabSelected === "product" ? !this.tvdProductDetailsData : !this.tvdLocationDetailsData;
    if (detailsDataNeeded) {
      const locationFilter = this.tabSelected === 'location' ? this.selectedLocationFilters : undefined;
      const productFilter = this.tabSelected === 'product' ? this.selectedProductFilters : undefined;

      // Conditionally pass costAssumptionMetrics only if it's defined
      const detailsData = await this._tvdService.getTVDDetailsData(
        this.groupBy,
        metricName,
        this.selectedProgram,
        metricCostAssumptions,
        this.navigationState.brandGroup,
        this.navigationState.brands,
        locationFilter,
        productFilter
      );

      if (this.tabSelected === "product") {
        this._tvdService.setTvdProductDetailsData(detailsData);
      } else {
        this._tvdService.setTvdLocationDetailsData(detailsData);
      }
    }

    this._mixpanelService.track('TVD View by ' + this.tabSelected + ' Loaded',{ MetricName: this.metricName });
    this.updateDetailsAndHeaders();
    this.updatePageData(0, this.paginator?.pageSize ?? 0);
  }

  // Get TVD Services Details Data
  async getTVDServicesDetailsDataAndUpdatePage(metricName: string) {    
    // TODO: Encapsulate the logic for converting the metricName into an eroid instead of having the caller do it and passing the eroid to the request function. This will make it easier to maintain and less error prone as we won't have to worry about callers passing in metric names that don't match the expected format.
    // The commented out line below is an example of how this could be done, but it would require changes to the request function and potentially other parts of the codebase so it may not be worth doing at this time.
    // const normalizedMetricName = this.normalizeMetricName(this.metricName);
    // Prepare costAssumptionMetrics if metricName is productivity
    let metricCostAssumptions: MetricCostAssumptions | undefined;
    let rates: { [key: string]: number; } | undefined;
      // TODO: Is formattedMetricName really a formatted metric name or an eroid? This is a bit confusing and can easily lead to bugs if we have metrics with similar names. We should consider having a clear mapping of metric display names to their corresponding cost assumption metric names to avoid this issue.
    const metricIds = componentConfigAndMetricsIdsMap.get(this.formattedMetricName) || [];

    if (this._tvdDetailsConfigService.isRetrievalRequiredFromAPI(this.metricName)) {
      const formData = this._tvdService.getFormData();
      const metrics: Record<string, number> = {};

      metricIds.forEach((key: string | number) => {
        // Convert to number, will be NaN if empty or invalid
        const value = Number(formData[key]);

        // Only add to metrics if it's a valid non-zero number
        if (!isNaN(value) && value !== 0) {
          metrics[key] = value;
        }
      });

      // Only set metricCostAssumptions if it's not empty
      const flatMetricCostAssumptions = new FlatMetricCostAssumptions();
      rates = Object.keys(metrics).length > 0 ? metrics : undefined;
      flatMetricCostAssumptions.rates = rates;
      metricCostAssumptions = flatMetricCostAssumptions;
    }

    //if we dont already have the data, then retrieve from endpoint
    const detailsDataNeeded = !this.tvdLocationServicesDetailsData;
    if (detailsDataNeeded) {
      const detailsData = Object.keys(rates || {}).length > 0
        ? await this._tvdService.getTVDServicesDetailsData(this.groupBy, metricName, metricCostAssumptions)
        : await this._tvdService.getTVDServicesDetailsData(this.groupBy, metricName);
      this.tvdLocationServicesDetailsData = detailsData;

      this._tvdService.setPestTvdLocationDetailsData(detailsData);
    }

    this._mixpanelService.track('TVD Pest View by ' + this.tabSelected + ' Loaded',{ MetricName: this.metricName });
    this.updateDetailsAndHeaders();
    this.updatePageData(0, this.paginator?.pageSize ?? 0);
  }

  updateDetailsAndHeaders() {
    const metricUnits = this._eroiService.mapIdToUnits(this.metricId);
    if(!this.isPestView()){
      if (this.tabSelected === "product") {
        this.setTVDProductDetails();
        this.tableProductHeaderColumns = this._tvdDetailsConfigService.setTableHeaderProductColumns(metricUnits);
      } else {
        this.setTVDLocationDetails();
        this.tableLocationHeaderColumns = this._tvdDetailsConfigService.setTableHeaderLocationColumns(metricUnits);
      }
    }else{
      this.setTVDLocationServicesDetails();
      this.tableLocationServicesHeaderColumns = this._tvdDetailsConfigService.setTableHeaderLocationServicesColumns(metricUnits, this.metricName);
    }

  }

  setTVDMetricValues() {
    const metric = this._tvdMetricResolver.resolve(this.metricId, this.groupId);
    if (!metric) {
      return;
    }

    // Match the dialog's original/modified value semantics.
    this.metricUnits = this._eroiService.mapIdToUnits(this.metricId);
    this.tvdDollars = Number(metric.monetaryContribution?.replace(/,/g, '')) || 0;
    this.modifiedTVDDollars = Number(metric.modifiedMonetaryContribution?.replace(/,/g, '')) || this.tvdDollars;
    this.tvdMetricQuantity = Number(metric.valueContribution?.replace(/,/g, '')) || 0;
    this.modifiedTvdMetricQuantity = Number(metric.modifiedValueContribution?.replace(/,/g, '')) || this.tvdMetricQuantity;
  }

  private setModifiedAverageTVDMetricDollars(): void {
    this.modifiedAvgTVDMetricDollars = Math.round(
      this.modifiedTVDDollars / this.getFormattedNumber(this.totalLocations)
    );
  }

  getLocationSiteInfo(location: TVDLocationDetailsRowData | TVDLocationServicesDetailsRowData) {
    // concat each field if not null streetAddress city, state and zip code
    return `${location.streetAddress ? location.streetAddress : ""},
      ${location.city ? location.city : ""}, ${
      location.state ? location.state : ""
    } ${location.zipCode ? location.zipCode : ""}`;
  }

  // #region Non-Pest Methods
  setTVDProductDetails() {
    this.totalLocations = this.tvdProductDetailsData?.totalLocations!;
    this.totalContributingProducts = this.tvdProductDetailsData?.totalContributingProducts!;
    this.avgTVDMetricDollars = this.getFormattedNumber(this.tvdProductDetailsData?.avgTVDMetricDollars!);
    this.avgTVDMetricQuantity = this.getFormattedNumber(this.tvdProductDetailsData?.avgTVDMetricQuantity!);
    this.tvdProductsRowData = this.tvdProductDetailsData?.productRows;
    this.setModifiedAverageTVDMetricDollars();

    // Capture raw API total before cost assumption modifications
    if (this.tvdProductsRowData?.length) {
      this.rawApiTotalDollars = this.tvdProductsRowData.reduce(
        (sum, r) => sum + (r.estimatedMetricDollars || 0), 0);
    }

    //Re-assign modifiedAvgTVDMetricDollars if cost assumption metrics are set
    if(!this.isCountryScopedCostAssumptions() && this.costAssumptionValue > 0) {
      if(this.metricName.toLowerCase() !== 'productivity') {
        this.tvdProductDetailsData?.productRows.forEach((product) => {
          if (this.metricName.toLowerCase() === "water") {
            product.estimatedMetricDollars = (this.costAssumptionValue * product.estimatedMetricQuantity) / 1000;
          } else {
            product.estimatedMetricDollars = this.costAssumptionValue * product.estimatedMetricQuantity;
          }
        });
      } else {
        this.tvdProductDetailsData?.productRows.forEach((product) => {
          product.estimatedMetricDollars = product.modifiedEstimatedMetricDollars;
        });
      }
    }
  }

  setTVDLocationDetails() {
    this.totalLocations = this.tvdLocationDetailsData?.totalLocations!;
    this.totalContributingProducts = this.tvdLocationDetailsData?.totalContributingProducts!;
    this.avgTVDMetricDollars = this.getFormattedNumber(this.tvdLocationDetailsData?.avgTVDMetricDollars!);
    this.avgTVDMetricQuantity = this.getFormattedNumber(this.tvdLocationDetailsData?.avgTVDMetricQuantity!);
    this.tvdLocationRowData = this.tvdLocationDetailsData?.locationRows;
    this.setModifiedAverageTVDMetricDollars();

    // Capture raw API total before cost assumption modifications
    if (this.tvdLocationRowData?.length) {
      this.rawApiTotalDollars = this.tvdLocationRowData.reduce(
        (sum, r) => sum + (r.estimatedMetricDollars || 0), 0);
    }

    //Re-assign modifiedAvgTVDMetricDollars if cost assumption metrics are set
    if(!this.isCountryScopedCostAssumptions() && this.costAssumptionValue > 0) {
      if(this.metricName.toLowerCase() !== 'productivity') {
        this.tvdLocationDetailsData?.locationRows.forEach((location) => {
          if (this.metricName.toLowerCase() === "water") {
            location.estimatedMetricDollars = (this.costAssumptionValue * location.estimatedMetricQuantity) / 1000;
          } else {
            location.estimatedMetricDollars = this.costAssumptionValue * location.estimatedMetricQuantity;
          }
      });
      } else {
        this.tvdLocationDetailsData?.locationRows.forEach((location) => {
          location.estimatedMetricDollars = location.modifiedEstimatedMetricDollars;
      });
      }
    }
  }

  // #endregion

  // #region Pest Service Method
  setTVDLocationServicesDetails() {
    this.totalLocations = this.tvdLocationServicesDetailsData?.totalLocations!;
    this.totalServices = this.tvdLocationServicesDetailsData?.totalServices!;
    this.avgTVDMetricDollars = this.getFormattedNumber(this.tvdLocationServicesDetailsData?.avgPerServiceCost!);
    // Format to 2 decimal places if the value is for PE CV multiplier
    // TODO : Might be extended to Furniture Preservation Energy if business decides so
    if(this.metricName.toLowerCase() === 'no charge additional services' || this.metricName.toLowerCase() === 'set-up services'){
      this.avgTVDMetricDollars = Math.round(this.avgTVDMetricDollars * 100) / 100;
    }
    this.secondaryMetricSum = this.getFormattedNumber(this.tvdLocationServicesDetailsData?.secondaryMetricSum!);
    this.tvdLocationServicesRowData = this.tvdLocationServicesDetailsData?.locationRows;

    // Capture raw API total before cost assumption modifications
    if (this.tvdLocationServicesRowData?.length) {
      this.rawApiTotalDollars = this.tvdLocationServicesRowData.reduce(
        (sum, r) => sum + (r.estimatedMetricDollars || 0), 0);
    }

    this.hasTwoMetrics = this._tvdDetailsConfigService.hasTwoMetricQuantities(this.metricName);
    this.hasTwoMultipliers = this._tvdDetailsConfigService.hasTwoMultipliers(this.metricName);
    this.avgMetricUnits = this._tvdDetailsConfigService.getAvgMetricUnitsForPest(this.metricName);

    //assign avgTVDMetricDollars, as we don't need to calculate the modifiedAvgTVDMetricDollars for these metrics which are calculated through BE
    if(this._tvdDetailsConfigService.isRetrievalRequiredFromAPI(this.metricName)){
      this.modifiedAvgTVDMetricDollars = this.avgTVDMetricDollars;
    }

    //Re-assign modifiedAvgTVDMetricDollars if cost assumption metrics are set
    // TODO: Should the code rely on costAssumptionValue or costAssumptionValue2? 
    if(this.costAssumptionValue > 0 || this.costAssumptionValue2 > 0) {
       //Set  modified averge value same as cost assumption value for furniture(energy)
      this.modifiedAvgTVDMetricDollars = this.costAssumptionValue > 0 ? this.costAssumptionValue :  this.modifiedAvgTVDMetricDollars;

      //Only update for metrics if needs to be calculated in FE
      if(!this._tvdDetailsConfigService.isRetrievalRequiredFromAPI(this.metricName)) {
        this.tvdLocationServicesDetailsData?.locationRows.forEach((location) => {
          // If both values are greater than zero
          // TODO: Should the code rely on costAssumptionValue or costAssumptionValue2? 
          if (this.costAssumptionValue > 0 && this.costAssumptionValue2 > 0) {
            location.estimatedMetricDollars = (this.costAssumptionValue * this.costAssumptionValue2) * location.estimatedMetricQuantity * this.secondMultiplier;
            this.modifiedAvgTVDMetricDollars = Math.round(this.modifiedTVDDollars / (this.getFormattedNumber(this.totalServices) * this.costAssumptionValue2 * this.secondMultiplier));
          }
          // TODO: Should the code rely on costAssumptionValue? 
          else if (this.costAssumptionValue > 0) { //only costAssumption is set
            location.estimatedMetricDollars = this.costAssumptionValue * location.estimatedMetricQuantity * this.secondMultiplier;
          }
          else {
            // For room nights saved, we need to account for default room price if only number of days was changed.
            let roomPriceMultiplier = 1;
            // TODO: Is formattedMetricName really a formatted metric name or an eroid? This is a bit confusing and can easily lead to bugs if we have metrics with similar names. We should consider having a clear mapping of metric display names to their corresponding cost assumption metric names to avoid this issue.
            // TODO: Refactor this if possible so that there is no hard-coded metric name
            if(this.formattedMetricName === eroiIds.ROOMNIGHTSSAVED){
              roomPriceMultiplier = this._tvdService.getDefaultRate("roomprice", null) as number;
            }
            location.estimatedMetricDollars = this.costAssumptionValue2 * location.estimatedMetricQuantity * this.secondMultiplier * roomPriceMultiplier;
            this.modifiedAvgTVDMetricDollars = Math.round(this.modifiedTVDDollars / (this.getFormattedNumber(this.totalServices) * this.costAssumptionValue2 * this.secondMultiplier));
          }
        });
      } else {
        this.tvdLocationServicesDetailsData?.locationRows.forEach((location) => {
          location.estimatedMetricDollars = location.modifiedEstimatedMetricDollars;
        });
      }
    }
  }

  //#endregion

  getFormattedDisplayNumber(value : number | undefined, attachCurrency : boolean = false){
    if(value === undefined || value === null){
      return "undefined";
    }

    if(attachCurrency){
      if(value <1 && value >0){
        return `< ${this.getCurrencySymbol()}1`
      }
      return `${this.getCurrencySymbol()} ${Math.round(value).toLocaleString('en-US')}`;
    }

    if(value < 1 && value > 0){
      return "<1";
    }
    return Math.round(value).toLocaleString('en-US');
  }

  getTotalValueDeliveryLink(): string {
    return this.filters?.division === 'Distributor' ? '/total-value-delivery-distributor' : '/total-value-delivery';
  }


  onPageChange(event: PageEvent) {
    this.updatePageData(event.pageIndex, event.pageSize);
  }

  updatePageData(pageIndex: number, pageSize: number) {
    const startIndex = pageIndex * pageSize;
    const endIndex = pageIndex * pageSize + pageSize;
    if(!this.isPestView()){
      if (this.tabSelected === "product") {
        this.tvdProductsRowDataPaginated = this.tvdProductsRowData?.slice(
          startIndex,
          endIndex
        );
      } else {
        this.tvdLocationRowDataPaginated = this.tvdLocationRowData?.slice(
          startIndex,
          endIndex
        );
      }
    }
    else{
      this.tvdLocationServicesRowDataPaginated = this.tvdLocationServicesRowData?.slice(
        startIndex,
        endIndex
      );
    }
  }

  toggleSortDirectionData(headerData : TVDTableHeader){
    // Toggle sort direction
    headerData.sortDirection = headerData.sortDirection === "asc" ? "desc" : "asc";

    // Track MixPanel Sort Event
    this._mixpanelService.track(`TVD ${this.tabSelected} Column ${headerData.title} Sorted`, {
      "Metric Name": this.metricName,
      "Sort Direction": headerData.sortDirection,
      "Sorted Column Name": headerData.title,
    });

    if(this.isPestView()){
      this.locationServicesSortBy = headerData.sortBy;
      this.tvdLocationServicesRowData = orderBy(this.tvdLocationServicesRowData, [headerData.sortBy], headerData.sortDirection);
    }
    else{
      // By Product
      if(this.tabSelected === "product" && this.tvdProductsRowData){
        // productSortBy is for styling purpose i.e displays which column has the toggle arrow
        this.productSortBy = headerData.sortBy;
        this.tvdProductsRowData = orderBy(this.tvdProductsRowData, [headerData.sortBy], headerData.sortDirection);
      }else{
        // By Location
        this.locationSortBy = headerData.sortBy;
        this.tvdLocationRowData = orderBy(this.tvdLocationRowData, [headerData.sortBy], headerData.sortDirection);
      }
    }

    // Update the page data
    if (this.paginator) {
      this.paginator.firstPage();
      this.updatePageData(0, this.paginator.pageSize);
    }
  }

  // Details changes
  changeTab(tab: string) {
    let prevTab = this.tabSelected;
    this.tabSelected = tab;

    this.buildAdvancedFilterData();
    this._router.navigate(["/total-value-delivery-details"], {
      queryParams: {
        metricId: this.metricId,
        groupId: this.groupId,
        groupBy: tab,
        metricName: this.metricName,
      },
    });
    this._mixpanelService.track(`TVD View by ${tab} Tab clicked`, { MetricName: this.metricName });
    this._mixpanelService.stopTrackingActiveTime();
    this._mixpanelService.trackPageView(` TVD ${this.metricName} ${prevTab}`);
    this._mixpanelService.initializeActiveDurationTracking();

  }


  onExportBtnClick(): void {
    this.isExportModalOpen = true;
    if (this.tabSelected === "location") {
      this.exportFileName = 'TVD_Location_Details';
      this.exportMixpanelEventName = `TVD Location Details`;
      this.exportModalTitle = 'Export Locations Data';
    } else {
      // product
      this.exportFileName = 'TVD_Product_Details';
      this.exportMixpanelEventName = `TVD Product Details`;
      this.exportModalTitle = 'Export Product Data';
    }
    this.additionalExportProperties = {MetricName: this.metricName};
  }

  handleExport(exportOptions: { fileName: string, fileType: string }): void {

    const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';

    let data: any[] = [];
    let columns: string[] = [];

    if(this.isPestView()){
      let format = this._tvdDetailsConfigService.formatPestExcelData(this.tvdLocationServicesRowData, this.tvdLocationServicesDetailsData?.metricUnit, this.metricName, this.costAssumptionValue2);
      data = format.data;
      columns = format.columns;
    }
    else{
      if (this.tabSelected === 'location') {
        let format = this._tvdDetailsConfigService.formatLocationExcelData(this.tvdLocationRowData, this.tvdLocationDetailsData?.metricUnit, this.metricName, this.filters?.regions,this.isCostAssumptionApplied());
        data = format.data;
        columns = format.columns;
      }
      else { //product
        let format = this._tvdDetailsConfigService.formatProductExcelData(this.tvdProductsRowData, this.tvdProductDetailsData?.metricUnit, this.metricName,this.isCostAssumptionApplied());
        data = format.data;
        columns = format.columns;
      }
    }

    const worksheet = XLSX.utils.json_to_sheet(data, { header: columns });
    const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    const blob = new Blob([excelBuffer], { type: EXCEL_TYPE });

    // Save the file using the provided logic
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `${exportOptions.fileName}.${exportOptions.fileType}`;
    link.click();
    window.URL.revokeObjectURL(url);
    this.closeExportModal();

  }

  //#region Helper Methods
  closeExportModal() {
    this.isExportModalOpen = false;
    this.isExportDownloading = false;
  }

  openSideDrawer() {
    this.isDrawerOpen = true;

    // Set interaction type context
    this._tvdCostAssumptionsService.setInteractionContext('Drill-in', this.metricName);

    // Push metrics to mixpanel
    this._mixpanelService.trackEventWithFilters('Opened the Cost Assumptions Side Navbar', this.filters,
      "Total Value Delivery",
      { 'Interaction Type': 'Drill-in',
        'Metric Type': this.metricName
      }
    );
  }

  closeSideDrawer() {
    this.isDrawerOpen = false;
  }

  isNoDollarValueMetric(): boolean {
    return this.noDollarValueMetrics.includes(this.metricName);
  }

  updateCostAssumptionsVisibility(): void {
    const isEligible = this._costAssumptionsEligibilityResolver.resolveFromFilters(this.filters);
    // For the non-pest in the drill-in view, we only want to show the cost assumptions if the metric is one of
    // the following: productivity, water, or energy. This is because these metrics have a direct impact on the
    // cost assumptions and are relevant for the user to see. For other metrics, we do not want to show the cost
    // assumptions as they may not be relevant or useful for the user. 
    // TODO: Consider moving this logic to a metric ID resolver if possible, as it would be more robust and less
    // brittle than relying on string matching of metric names.
    const isCurrentMetricEligible = ['productivity', 'water', 'energy'].includes(this.metricName.toLowerCase());
    this.costAssumptionsVisible = this.isPestView() ? isEligible : (isEligible && isCurrentMetricEligible);
  }

  getFormattedNumber(value : any) : number{
    return this._parseNumberPipe.transform(value);
  }

  getFormattedDisplayNumberFromString(value: string) : string {
    var number = this.getFormattedNumber(value);
    return this.getFormattedDisplayNumber(number);
  }

  isPestView(): boolean {
    return this.filters?.division === 'Pest';
  }

  // Used by the template to decide whether to display the cost-assumption-modified dollar value
  isCostAssumptionApplied(): boolean {
    return this.hasEnteredCostAssumption();
  }

  getRowEstimatedMetricDollars(row: { estimatedMetricDollars: number; modifiedEstimatedMetricDollars: number } | undefined): number | undefined {
    if (!row) {
      return undefined;
    }
    // Fall back to estimatedMetricDollars when modified value is missing OR zero
    return this.isCostAssumptionApplied() && row.modifiedEstimatedMetricDollars
      ? row.modifiedEstimatedMetricDollars
      : row.estimatedMetricDollars;
  }

  private isCountryScopedCostAssumptions(): boolean {
    return this._costAssumptionsLayoutResolver.resolveFromFilters(this.filters) === 'byCountry';
  }

  private hasEnteredCostAssumption(): boolean {
    const formData = this._tvdService.getFormData();
    const metricIds = this.metricName.toLowerCase() === 'productivity'
      ? componentConfigAndMetricsIdsMap.get(eroiIds.PRODUCTIVITY) || []
      : [this.metricName.toLowerCase()];

    if (this.isCountryScopedCostAssumptions()) {
      return Object.values(formData).some(countryRates => {
        if (!countryRates || typeof countryRates !== 'object') {
          return false;
        }

        const rates = countryRates as Record<string, string | number>;
        return metricIds.some(metricId => this.hasEnteredValue(rates[metricId]));
      });
    }

    return metricIds.some(metricId => this.hasEnteredValue(formData[metricId]));
  }

  private hasEnteredValue(value: unknown): boolean {
    return value !== undefined && value !== null && String(value).trim() !== '';
  }

  //format metric name for the getTVDDetails endpoint
  //remove parenthesis for Furniture Preservation (Assets/Energy)
  normalizeMetricName(metricName: string) {
    return metricName.split(" ").join("-").replace('(', '').replace(')', '').toLowerCase();
  }

  getFormattedPestMetricName(metricName: string) {
    return metricName.replace(/[()\-]/g, '').split(" ").join("_").toLowerCase();
  }

  getCurrencySymbol() {
    this.currencyCode = this._currencyUomService.getDisplayedCurrency();
    this.currencySymbol = this._currencySymbolPipe.transform(this.currencyCode);
    return this.currencySymbol;
  }

  buildKpiCards(): void {
    const metric = this._tvdMetricResolver.resolve(this.metricId, this.groupId);
    if (!metric) {
      return;
    }

    const metricData = this._tvdMetricDisplayDataBuilder.build(metric);

    // TODO: Consider moving this logic to a metric ID resolver if possible
    const metricId = this.metricName === this.ROOMS_NIGHTS_SAVED ? 'numberofroomnights' : 
    this.metricName ===this.NO_CHARGE_ADDITIONAL_SERVICES ? 'rodentservicemultiplier' : 'setupservicescomultiplier'; 

    // TODO: Consider moving this to a rate resolver if possible
    const rate = metricId ? this.getRate(metricId) : '';
    const defaultRate = metricId ? this.getDefaultRate(metricId) : '';

    this.tvdDrillInMetricTiles = this._tvdKpiCardBuilder.build({
      layout: this.isPestView() ? KpiCardLayout.Pest : KpiCardLayout.Standard,
      metricId: this.metricId,
      metricName: this.metricName,
      tvdDollars: Number((metricData.defaultMonetaryContribution || '0').replace(/,/g, '')),
      modifiedTVDDollars: Number((metricData.currentMonetaryContribution || '0').replace(/,/g, '')),
      hasCostAssumption: this.isPestView()
        ? metricData.isMonetaryContributionModified || metricData.isValueContributionModified
        : this.hasEnteredCostAssumption() || metricData.isMonetaryContributionModified || metricData.isValueContributionModified,
      tvdMetricQuantity: Number((metricData.defaultValueContribution || '0').replace(/,/g, '')),
      modifiedTvdMetricQuantity: Number((metricData.currentValueContribution || '0').replace(/,/g, '')),
      totalLocations: this.totalLocations,
      totalContributingProducts: this.totalContributingProducts,
      avgTVDMetricDollars: this.avgTVDMetricDollars,
      modifiedAvgTVDMetricDollars: this.modifiedAvgTVDMetricDollars,
      avgTVDMetricQuantity: this.avgTVDMetricQuantity,
      avgMetricUnits: this.avgMetricUnits,
      currencySymbol: this.getCurrencySymbol(),
      hasTwoMetrics: this.hasTwoMetrics,
      secondaryMetricSum: this.secondaryMetricSum,
      rate: rate,
      defaultRate: defaultRate,
      costAssumptionValue2: this.costAssumptionValue2,
    });
  }

   //#endregion

  ngOnDestroy(): void {
    if (this.filtersSubscription) {
      this.filtersSubscription.unsubscribe();
    }
    if (this.tvdLocationsDetailsSubscription) {
      //reset tvdLocationDetailsData
      this._tvdService.setTvdLocationDetailsData(undefined);
      this.tvdLocationsDetailsSubscription.unsubscribe();
    }
    if (this.tvdProductDetailsSubscription) {
      //reset tvdProductDetailsData
      this._tvdService.setTvdProductDetailsData(undefined);
      this.tvdProductDetailsSubscription.unsubscribe();
    }
    if (this.tvdPestLocationsDetailsSubscription) {
      //reset tvdPestLocationDetailsData
      this._tvdService.setPestTvdLocationDetailsData(undefined);
      this.tvdPestLocationsDetailsSubscription.unsubscribe();
    }
    this.modifiedTVDDollarsSubscription?.unsubscribe();
    this.currencySubscription?.unsubscribe();
    this.loadingOverlaySubscription?.unsubscribe();
    this._mixpanelService.stopTrackingActiveTime();
    this._mixpanelService.trackPageView(`TVD ${this.metricName} ${this.tabSelected}`); //send page view event, which includes Page Name and Active Duration
  }

  // Rates
  // TODO: The method name is misleading as it is not actually performing a fetch but it is subscribing to an observable. Consider renaming it to better reflect its behavior.
  private async fetchTvdRateDetails() {
    try {
      if (this.filters?.division && this.filters.regions) {
        this._tvdService.tvdRateDetailsData$(this.filters.division, this.filters.regions).subscribe({
          next: (data) => {
            this.tvdRateDetailsResponse = data;
            // For pest metrics with rates (Room Nights Saved and Set-up Services), 
            // build the drill-in titles after fetching the rates to ensure they are included in the titles.
            // This is necessary because the rates are used in the drill-in titles for these metrics, 
            // and we want to ensure that the latest rates are reflected in the titles when the drill-down modal is opened.
            // TODO: Why are we doing this only for ROOMS_NIGHTS_SAVED and SETUP_SERVICES? Should we consider other metrics as well? 
            if(this.metricName === this.ROOMS_NIGHTS_SAVED  || this.metricName === this.SETUP_SERVICES){
              this.buildKpiCards();
            }
           }
        });
      }
    } catch (error) {
      console.error('Unexpected error occurred while fetching TVD Rate Details:', error);
    }
  }

  getRate(metricId:string, isDecimal:boolean=true){
    const savedMetricData = this.getSavedMetricData(metricId);
    if (savedMetricData) {
      const rate = savedMetricData;
      return isDecimal ? rate : parseFloat(rate as string)
    }

    return this.getDefaultRate(metricId, isDecimal);
  }

  getSavedMetricData(metricId:string){
    const savedFormData: ModifiedFormData = this._tvdService.getFormData();
    return savedFormData ? savedFormData[metricId] : undefined;
  }

  getDefaultRate(metricId:string,isDecimal:boolean=true){
    let rate = (this.tvdRateDetailsResponse?.tvdRateDetails?.find(x => x.id ===metricId)?.rate ?? 0).toFixed(2);
    return isDecimal ? rate : parseFloat(rate);
  }

  getMeasurementUnit(product: TVDProductDetailsRow): string {
    if (product.measurementCategory === 'Liquid') {
        return 'Gallons';
    }
    if (product.isEDPRental) {
        return 'Months';
    }
    return 'Cases';
  }

  async loadAdvancedFilterOptions() {
    if (!this.ELIGIBLE_FILTER_DIVISIONS.includes(this.filters?.division || '')) {
      return;
    }

    this.displayLoaderForFilterData = true;
    const normalizedMetricName = this.normalizeMetricName(this.metricName);

    this.advancedFilterOptions = await this._tvdService.getTVDAdvancedFilterOptions(
      normalizedMetricName,
      this.selectedProgram,
      this.navigationState.brandGroup,
      this.navigationState.brands
    );

    if (this.advancedFilterOptions) {
      this.buildAdvancedFilterData();
    }

    this.displayLoaderForFilterData = false;
  }

  buildAdvancedFilterData() {
    if (!this.advancedFilterOptions) return;
    
    //Use a Set to get the distinct values, also arrange the properties in the desired display order
    const orderedAndDistinctFilterOptions : TvdAdvancedFilterOption[] = 
                [...new Set(this.advancedFilterOptions.map(c => (
                  { 
                    siteNumber:c.siteNumber, 
                    siteName: c.siteName, 
                    country: c.country, 
                    state: c.state, 
                    city: c.city,
                    zipCode: c.zipCode,
                    productGroup: c.productGroup,
                    productName: c.productName,
                    productSku: c.productSku
                  }
                )))]
              

    // Exclude advanced filter options based on the selected tab.
    this.excludeKeys = this.tabSelected === 'location' 
              ? ['productGroup', 'productName', 'productSku'] 
              : ['siteNumber', 'siteName', 'country', 'state', 'city', 'zipCode'];

    
    this.advancedFilterData = orderedAndDistinctFilterOptions;
    this.updateCurrentSelectedFilters();
  }

  async onSelectedFiltersChange(selectedFilters: { [id: string]: string[] }) {
    if (this.tabSelected === 'location') {
      this.selectedLocationFilters = {
        siteNumber: selectedFilters['siteNumber'],
        siteName: selectedFilters['siteName'],
        country: selectedFilters['country'],
        state: selectedFilters['state'],
        city: selectedFilters['city'],
        zipCode: selectedFilters['zipCode']
      };
    } else {
      this.selectedProductFilters = {
        productGroup: selectedFilters['productGroup'],
        productName: selectedFilters['productName'],
        productSku: selectedFilters['productSku']
      };
    }

    this.updateCurrentSelectedFilters();

    if (this.tabSelected === TvdDrillDownGrouping.Product) {
      this._tvdService.setTvdProductDetailsData(undefined);
    } else {
      this._tvdService.setTvdLocationDetailsData(undefined);
    }

    if (this.paginator) {
      this.paginator.firstPage();
    }

    await this.updateTVDDetails();
  }

  updateCurrentSelectedFilters() {
    if (this.tabSelected === 'location') {
      this.currentSelectedFilters = {
        siteNumber: this.selectedLocationFilters.siteNumber || [],
        siteName: this.selectedLocationFilters.siteName || [],
        country: this.selectedLocationFilters.country || [],
        state: this.selectedLocationFilters.state || [],
        city: this.selectedLocationFilters.city || [],
        zipCode: this.selectedLocationFilters.zipCode || [],
        productGroup: [],
        productName: [],
        productSku: []
      };
    } else {
      this.currentSelectedFilters = {
        siteNumber: [],
        siteName: [],
        country: [],
        state: [],
        city: [],
        zipCode: [],
        productGroup: this.selectedProductFilters.productGroup || [],
        productName: this.selectedProductFilters.productName || [],
        productSku: this.selectedProductFilters.productSku || []
      };
    }
  }

  shouldShowAdvancedFilters(): boolean {
    return this.ELIGIBLE_FILTER_DIVISIONS.includes(this.filters?.division || '');
  }

  goBackToMainTvdPage() {
    // Navigate to appropriate TVD page based on division filter
    const route = this.filters?.division === 'Distributor' ? '/total-value-delivery-distributor' : '/total-value-delivery';
    this._router.navigate([route]); 
  }

}
